export class PopupMessage{
    messageID: number;
    code: string;
    title: string;
    header: string;
    message: string;
    agreeText: string;
    doNotAgreeText: string;
    btnOkText: string;
    btnCancelText: string;
    titleHide: number;
    headerHide: number;
    messageHide: number;
    agreeHide: number;
    doNotAgreeHide: number;
    btnOkHide: number;
    btnCancelHide: number;
    active: number;
}